import { useIntl } from "react-intl";
import { ACTION_VALUE_TYPES, isKnownActionKey } from "../domain/globalAction.types";
import { useEnumOptions } from "../hooks/useEnumOptions";
import { actionModalMessages } from "../../orchestrator.messages";

export function parseCommaSeparated(value: string): string[] {
  if (!value || !value.trim()) return [];
  return value
    .split(",")
    .map(s => s.trim())
    .filter(s => s.length > 0);
}

export function isValidUrl(value: string): boolean {
  if (!value || !value.trim()) return true; // Empty is valid (optional)
  try {
    new URL(value);
    return true;
  } catch {
    return false;
  }
}

export function useFormatActionValue(): (key: string, value: string) => string {
  const intl = useIntl();
  const { getEnumLabel } = useEnumOptions();

  const yes = intl.formatMessage(actionModalMessages.yes);
  const no = intl.formatMessage(actionModalMessages.no);

  return (key: string, value: string): string => {
    if (!value) return "—";

    if (isKnownActionKey(key)) {
      const valueType = ACTION_VALUE_TYPES[key];

      if (valueType === "boolean") {
        return value.toLowerCase() === "true" ? yes : no;
      }

      if (valueType === "enum") {
        return getEnumLabel(key, value) ?? value;
      }

      if (valueType === "stringList") {
        const items = parseCommaSeparated(value);
        return items.length > 0 ? items.join(", ") : "—";
      }
    }

    return value;
  };
}
